import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import Button from '../../Shared/Button';
import '../../../css/GenericServices/PaymentDetailsTransportationGS.css';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import CancelModal from '../../Shared/CancelModalMarketPlace';
import RejectModal from '../../Shared/TranspotationRejectModal';
import Input from '../../Shared/Input';
import edit from '../../../Assets/ProfileManagement/Assets-Desktop/edit.svg';
import bigBlankStar from '../../../Assets/NominateRequest/starBlank_large.svg';
import bigFilledStar from '../../../Assets/NominateRequest/starFilled_large.svg';
import StarRatingModal from '../../Shared/StarRatingModal';
import Message from '../../../Data/Shared/Message.json';
import '../../../css/Shared/FilesWithStarModal.css';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { serviceBaseURL } from '../../../Services/config/apiGateway';
import { ALLANNOUNCEMENTS_ENDPOINT } from '../../../Services/config/apiEndPoints';
class PaymentDetailsTransportationGS extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            serviceCharge: '150.00',
            transactionFees: '10.00',
            discount: '1.00',
            beforeTaxes: '9.00',
            VAT: '1.35',
            orderTotal: '10.35',
            serviceChargePay: false,
            hasOpen: false,
            hasOPenReject: false,
            reason: '',
            reasonTextLimit: 0,
            hasOpenRating: true,
            ratingStar: '',
            errorStarReason: "",
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    onYesModal = () => {
        this.setState({ hasOpen: false });
    };
    onCloseModal = () => {
        this.setState({ hasOpen: false });
    };
    onCloseReject = () => {
        this.setState({ hasOPenReject: false });
    };
    handleChangeComment = (e) => {
        if (e.target.value.length <= 50) {
            this.setState({ reasonTextLimit: e.target.value.length });
            this.setState({ reason: e.target.value });
        }
    }
    updateRating = (index) => {
        this.setState({ ratingStar: index + 1 });
        this.setState({ errorStarReason: '' });
    }
    onSumbitRating = () => {
        if (this.handleValidationModel()) {
            document.documentElement.scrollTop = 0;
            this.setState({ hasOpenRating: false });
        }
    };
    handleValidationModel = () => {
        let errorStarReason = '';
        let formIsValid = true;
        if (this.state.hasOpenRating == true) {
            if (!this.state.ratingStar) {
                formIsValid = false;
                errorStarReason = Message.validation.rating;
            }
        }
        this.setState({ errorStarReason: errorStarReason })
        return formIsValid;
    }
    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
    }
    handleClickOutside = event => { };
    onProceed = () => {
        ApiCall(
            'POST',
            serviceBaseURL + ALLANNOUNCEMENTS_ENDPOINT,
            {
                "requestsSummary": {
                    "serviceRequestId": 12345,
                    "serviceDetail": {
                        "serviceType": "Transportation service",
                        "startDateTime": "ddmmyyyyhhmmss",
                        "status": "In Progress, Completed",
                        "requestorCompanyName": "XYZ company",
                        "location": "Durban",
                        "publishDateTime": "ddmmyyyyhhmmss",
                        "endDateTime": "ddmmyyyyhhmmss",
                        "rfqDateTime": "ddmmyyyyhhmmss"
                    }
                },
                "serviceRequestData": "CDATA[json data]",
                "transactionDetails": 1000,
                "paymentMethod": "offline",
                "respondents": {
                    "amount": 1000,
                    "selectedRespondent": {
                        "companyName": "XYZ company",
                        "location": "Durban",
                        "email": "abc@xyz.com",
                        "mobileNumber": 987654321,
                        "rating": "5",
                        "cancellationPolicy": "Flexible",
                        "comments": "some comments",
                        "docPath": "/sharePoint/xyz.pdf"
                    },
                    "otherRespondents": [
                        {
                            "companyName": "XYZ company",
                            "location": "Durban",
                            "email": "abc@xyz.com",
                            "mobileNumber": 987654321,
                            "rating": "5",
                            "cancellationPolicy": "Flexible",
                            "comments": "some comments",
                            "docPath": "/sharePoint/xyz.pdf"
                        }
                    ]
                }
            },
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        ).then(data => {
            if (data.flag != -1) {
                if (data.flag == '500') {
                    console.log('I am 500!');
                } else {
                    console.log('I am 200!');
                }
            }
            else {
                console.log('Something went wrong!');
            }
        });
    }
    render() {
        return (
            <div class="MPaymentDOutercolor">
                <MetaDecorator title={TitleDescription.PaymentDetailsTransportationGSTitle} description={TitleDescription.PaymentDetailsTransportationGSDescription} />
                <Header tilesFetched={() => { }} />
                <div class="MPaymentDOuterDivcss">
                    <div id="MPaymentDBoxDiv">
                        <nav class="MPaymentDNavbar">
                            <div className="MPaymentDNavbarName">
                                <small id="MPaymentDNavbarText">Payment Details</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="MPaymentDMidPartition">
                            <div class="MPaymentDCardCss">
                                <div class="MPaymentDCardInner">
                                    <div class="MPaymentDCardRow">
                                        <small class="MPaymentDCardTextLeft">Service Charge</small>
                                        {this.state.serviceChargePay ?
                                            <small class="MPaymentDCardOrderRight">R {this.state.serviceCharge}</small>
                                            :
                                            <small class="MPaymentDCardOrderRight">NA*</small>
                                        }
                                    </div>
                                </div>
                                <div class="MPaymentDCardInner">
                                    <div class="MPaymentDCardRow">
                                        <small class="MPaymentDCardTextLeft">Transaction Fees</small>
                                        <small class="MPaymentDCardTextRight">R {this.state.transactionFees}</small>
                                    </div>
                                    <div class="MPaymentDCardRow">
                                        <small class="MPaymentDCardTextLeft">Discount (10%)</small>
                                        <small class="MPaymentDCardTextRight">R {this.state.discount}</small>
                                    </div>
                                    <div class="MPaymentDCardRow">
                                        <small class="MPaymentDCardTextLeft">Before Taxes</small>
                                        <small class="MPaymentDCardTextRight">R {this.state.beforeTaxes}</small>
                                    </div>
                                    <div class="MPaymentDCardRow">
                                        <small class="MPaymentDCardTextLeft">VAT (15%)</small>
                                        <small class="MPaymentDCardTextRight">R {this.state.VAT}</small>
                                    </div>
                                </div>
                                <div class="MPaymentDCardOrder">
                                    <div class="MPaymentDCardRow">
                                        <small class="MPaymentDCardOrderLeft">Order Total</small>
                                        <small class="MPaymentDCardOrderRight">R {this.state.orderTotal}</small>
                                    </div>
                                </div>
                            </div>
                            {!this.state.serviceChargePay &&
                                <div class='serviceChargeDiv'>*
                                <small class="serviceChargeLeft"> Service Charge </small>
                                    <small class='serviceChargeRight'>to be settled directly with Respondent in accordance with the agreed payment
terms stipulated on the service response.</small>
                                </div>
                            }
                            <div class="MPaymentDBtnDiv">
                                <Button class="MPaymentDBtnCss" onClick={this.onProceed}>
                                    <small class="MPaymentDBtntext">Proceed To Pay</small>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="MPaymentDFooterUnfixed">
                    <Footer />
                </div>
                <div class="MPaymentDFooterFixed">
                    <Footer2 />
                </div>
                <CancelModal hasOpen={this.state.hasOpen} onCloseModal={this.onCloseModal} onYesModal={this.onYesModal}>
                    <div>
                        <div class="cancelTransportationServiceDiv">
                            <small class="transportationServiceText">Do you want to cancel this request?</small>
                            <small class="transportationServiceTextSmall" id='transportationDesk'>If you have already made the payment the refund</small>
                            <small class="transportationServiceTextSmall" id='transportationDesk'> will be initiated based on the cancellation policy.</small>
                            <small class="transportationServiceTextSmall" id='transportationMobile'>If you have already made the payment the refund will be initiated based on the cancellation policy.</small>
                        </div>
                    </div>
                </CancelModal>
                {this.state.hasOPenReject ? <RejectModal hasOpen={this.state.hasOPenReject} onCloseModal={this.onCloseReject} >
                    <div>
                        <div class="successtext1outercreatepreadvise">
                            <small class="rejectModalHeading">Are you sure you want to reject this quotation?</small>
                        </div>
                        <div class="rejectMainDiv">
                            <div className="pass-wrapper" id="rejectInputDiv" >
                                <Input
                                    name="Comment"
                                    class="input" placeholder="Please enter your reason"
                                    type="text" id="CrtTptReqestInpCss" value={this.state.reason}
                                    onChange={this.handleChangeComment}
                                />
                                <i id="rejectInputIcon">
                                    <img src={edit} />
                                </i>
                                <small class="inpsmallraise">{this.state.reasonTextLimit}/50</small>
                            </div>
                        </div>
                    </div>
                </RejectModal> : null}
                <StarRatingModal hasOpen={this.state.hasOpenRating} onCloseModal={() => this.onSumbitRating()}>
                    <div class="newratingDivOut">
                        <div class="newratingHeadDiv">
                            <small class="newratingHeadsm">Please rate Respondent services
for Quotation ID XXX</small>
                        </div>
                        <div class="newratingLowerSectionDiv">
                            <div class="newratingNameHeadingDiv">
                                <small class="newratingNameHeading">Rate ABC Transport Limited</small>
                            </div>
                            <div class="newratingImgDiv">
                                <div class="newratingImgDivin">
                                    {[1, 1, 1, 1, 1].map((item, index) => (
                                        <div class="newratingmodalimgposition"
                                            onClick={() => this.updateRating(index)}
                                            key={index}
                                        >
                                            <img src={index < this.state.ratingStar ? bigFilledStar : bigBlankStar} class="newratingImgStar" height="26" width="26" alt="" loading="lazy" />
                                        </div>
                                    ))}
                                </div>
                                <div className="newratingstarunfillerror">{this.state.errorStarReason}</div>
                            </div>
                        </div>
                        <div class="rejectMainDiv">
                            <div className="pass-wrapper" id="rejectInputDiv" >
                                <Input
                                    name="Comment"
                                    class="input" placeholder="Please enter your comment"
                                    type="text" id="CrtTptReqestInpCss" value={this.state.reason}
                                    onChange={this.handleChangeComment}
                                />
                                <i id="rejectInputIcon">
                                    <img src={edit} />
                                </i>
                                <small class="inpsmallraise">{this.state.reasonTextLimit}/50</small>
                            </div>
                        </div>
                    </div>
                </StarRatingModal>
            </div >
        );
    }
}
export default PaymentDetailsTransportationGS;